"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cwt = exports.sqin = exports.sqft = exports.inch = exports.ft = exports.pcs = exports.pc = exports.lbs = exports.lb = void 0;

var enums_1 = require("./enums");

exports.lb = {
  value: enums_1.UOMValue.LB,
  display: enums_1.UOMDisplay.LB
};
exports.lbs = {
  value: enums_1.UOMValue.LB,
  display: enums_1.UOMDisplay.LBS
};
exports.pc = {
  value: enums_1.UOMValue.PC,
  display: enums_1.UOMDisplay.PC
};
exports.pcs = {
  value: enums_1.UOMValue.PC,
  display: enums_1.UOMDisplay.PCS
};
exports.ft = {
  value: enums_1.UOMValue.FT,
  display: enums_1.UOMDisplay.FT
};
exports.inch = {
  value: enums_1.UOMValue.IN,
  display: enums_1.UOMDisplay.IN
};
exports.sqft = {
  value: enums_1.UOMValue.FT2,
  display: enums_1.UOMDisplay.FT2
};
exports.sqin = {
  value: enums_1.UOMValue.SQIN,
  display: enums_1.UOMDisplay.SQIN
};
exports.cwt = {
  value: enums_1.UOMValue.CWT,
  display: enums_1.UOMDisplay.CWT
};